var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showViewer
    ? _c("el-image-viewer", {
        attrs: {
          "initial-index": _vm.initialIndex,
          "on-close": _vm.hide,
          "url-list": _vm.imageViewerSrcList,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }